<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.625 25.8751H10.5C8.844 25.8751 7.5 27.2191 7.5 28.8751V43.1251C7.5 44.7811 8.844 46.1251 10.5 46.1251H17.625L29.562 56.2381C31.512 57.8911 34.5 56.5051 34.5 53.9491V18.0511C34.5 15.4951 31.509 14.1091 29.562 15.7621L17.625 25.8751Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.611 47.9339C50.097 45.7679 52.5 41.2619 52.5 36.0149C52.5 30.7679 50.097 26.2589 46.611 24.0659"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.515 57.1951C60.939 52.5301 64.5 44.7901 64.5 36.0091C64.5 27.2161 60.933 19.4701 55.5 14.8081"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
